import React from "react";
import "../../Styles/certified/bct.css";

export default function Finzly() {
  return (
    <>
      <div className="bct-certified-details-section">
        <div className="bct-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="bct-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="bct-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="bct-certified-badge"
            />
            <div className="bct-certified-company-names">
              <a href="https://www.bct-consulting.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/bct/bct.png"
                alt="Walkzero Logo"
                className="bct-certified-company-logo"
              />
            </a>
              <h1 className="bct-certified-full-name">
             BCT Consulting Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="bct-certified-details-right">
            <img
              src="/assets/bct/bct_6.jpg"
              alt="Finzly Office"
              className="bct-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="bct-certified-description">
          <h2>
            Why  BCT Consulting Private Limited is an Outstanding Workplaces
          </h2>
          <p>
            BCT Consulting is a global leader in digital transformation products and services, offering reliable, innovative solutions that drive significant growth in revenue and operational excellence. With a presence in more than 20 countries, we specialise in enterprise services, knowledge process outsourcing (KPO), and staff augmentation. Our comprehensive suite of services includes middleware and integration, infrastructure managed services, application development and maintenance, tax services, audit services, and intelligent process automation. Serving diverse sectors such as banking, government, telecoms, and energy, BCT Consulting delivers innovative digital solutions that enhance growth, revenue, and operational excellence. Our commitment to excellence has earned us a reputation as an award-winning partner, empowering businesses worldwide.

          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="bct-certified-info-cards">
          <div className="bct-certified-info-card">
            <div className="bct-certified-info-title">COMPANY SIZE</div>
            <div className="bct-certified-info-value">1,800 Employees</div>
          </div>
          <div className="bct-certified-info-card">
            <div className="bct-certified-info-title">INDUSTRY</div>
            <div className="bct-certified-info-value">  IT Services & IT Consulting

</div>
          </div>
          <div className="bct-certified-info-card">
            <div className="bct-certified-info-title">CONNECT</div>
            <div className="bct-certified-info-icons">
              <span className="bct-certified-icon-round">
                <a href="https://www.bct-consulting.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="bct-certified-icon-round">
                <a href="https://www.linkedin.com/company/bctcglobal/posts/?feedView=all&viewAsMember=true" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="bct-certified-icon-round">
                <a href="https://www.facebook.com/BCTCGlobal" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="bct-certified-info-card">
            <div className="bct-certified-info-title">LOCATION (HQ)</div>
            <div className="bct-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="bct-certified-recognition-section">
          <h2 className="bct-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="bct-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="bct-certified-recognition-image"
            />
          </div>
          <div className="bct-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="bct-certified-life-section">
          <h2 className="bct-certified-life-title">
            Life at BCT Consulting Private Limited
          </h2>
          <div className="bct-certified-life-gallery">
            <div className="bct-certified-life-col">
              <img src="/assets/bct/bct_1.jpeg" alt="Office 1" className="bct-certified-life-img" />
              <img src="/assets/bct/bct_2.jpg" alt="Team 1" className="bct-certified-life-img" />
            </div>
            <div className="icom-certified-life-col bct-certified-life-center">
              <img src="/assets/bct/bct_5.jpg" alt="Main Office" className="bct-certified-life-img bct-certified-life-img-large" />
            </div>
            <div className="bct-certified-life-col">
              <img src="/assets/bct/bct_3.jpg" alt="Office 2" className="bct-certified-life-img" />
              <img src="/assets/bct/bct_4.jpeg" alt="Team 2" className="bct-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}